import { render, staticRenderFns } from "./tenantAccountOpening.vue?vue&type=template&id=73dc6ef0&scoped=true"
import script from "./tenantAccountOpening.vue?vue&type=script&lang=js"
export * from "./tenantAccountOpening.vue?vue&type=script&lang=js"
import style0 from "./tenantAccountOpening.vue?vue&type=style&index=0&id=73dc6ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc6ef0",
  null
  
)

export default component.exports